import { Anchor } from 'grommet/components/Anchor';
import { Link } from 'react-router-dom';

export default function AnchorLink(props) {
  return <Anchor as={({ ...p }) => <Link {...p} />} {...props} />;
}
